import { ORDER_STATUS } from '@bagonboard/wiseman';

const {
  AWAITING,
  CLOSED,
  CONFIRMED,
  OPEN,
} = ORDER_STATUS;

export default function getOrderStatusDetails(status) {
  switch (status) {
    case AWAITING:
      return {
        color: '#1973e8',
        text : 'Awaiting',
      };
    case CLOSED:
      return {
        color: '#d0505f',
        text : 'Closed',
      };
    case CONFIRMED:
      return {
        color: '#1973e8',
        text : 'Confirmed',
      };
    case OPEN:
      return {
        color: '#1973e8',
        text : 'Open',
      };
    default:
      return {
        color: '#1973e8',
        text : 'No status',
      };
  }
}
